import { resolveUrl } from '@portals/geo-utils';

export const environment = {
    hostPay       : resolveUrl(window.HOST_PAY || import.meta.env.APP_HOST_PAY),
    hostCallCenter: resolveUrl(window.HOST_CALL_CENTER || import.meta.env.APP_HOST_CALL_CENTER),
    hostSellerAuth: resolveUrl(window.HOST_SELLER_AUTH || import.meta.env.APP_HOST_SELLER_AUTH),
    hostApiMain   : '/',
    sdkApiUrl     : window.SDK_API_URL || import.meta.env.SDK_API_URL || '/portal-gate',
    sdkEnv        : window.SDK_ENV || import.meta.env.SDK_ENV || 'custom',
    sdkOrigin     : window.SDK_ORIGIN || import.meta.env.SDK_ORIGIN || window.location.origin || 'http://localhost:8080'
} as const;

export default environment;
